'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Container, Row, Col } from 'reactstrap';
import { useRouter, useSearchParams } from 'next/navigation';
import queryString from 'query-string';
import BlogpostTeaser from './BlogpostTeaser';
import Pager from '../Pager';
import scrollToTop from '../../utils/scrollToTop';
import { Dictionaries, Locale } from '../../i18n/i18n-config';
import { getI18nUtils } from '../../i18n/i18n-utils';

type Props = {
  blogposts: any;
  className?: string;
  pageInfo: { currentPage: number; totalPages: number };
  availableTags: any[];
  availableCategories: any[];
  count: number;
  dictionary: Partial<Dictionaries>;
  locale: Locale;
  scrollTop?: boolean;
  path?: string;
};
function Blog({
  blogposts,
  className,
  pageInfo,
  availableTags,
  availableCategories,
  count,
  dictionary,
  locale,
  scrollTop = true,
  path,
}: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const searchParams = useSearchParams();
  const tags = searchParams.get('tags');
  const categories = searchParams.get('categories');

  const activeTags = tags ? tags.split(',') : [];
  const activeCategories = categories ? categories.split(',') : [];

  const handleRoute = ({ page = 1, category, tag }: any) => {
    const queryBuild = { page, tags: activeTags, categories: activeCategories };

    if (tag) {
      const tagIndex = queryBuild.tags.indexOf(tag);
      if (tagIndex === -1) queryBuild.tags.push(tag);
      else queryBuild.tags = queryBuild.tags.filter((tg) => tg !== tag);
    }
    if (category) {
      const categoryIndex = queryBuild.categories.indexOf(category);
      if (categoryIndex === -1) queryBuild.categories.push(category);
      else queryBuild.categories = queryBuild.categories.filter((cat) => cat !== category);
    }
    const query: any = { page };
    if (queryBuild.tags && queryBuild.tags.length > 0) query.tags = queryBuild.tags.join(',');
    if (queryBuild.categories && queryBuild.categories.length > 0) query.categories = queryBuild.categories.join(',');
    const newQueryString = queryString.stringify(query);

    push(`/${locale}/${path ? path + '/' : ''}blog?${newQueryString}`, { scroll: false });
    if (scrollTop) scrollToTop();
  };

  return (
    <Container className={className || 'my-5'}>
      <Row>
        <Col lg="3">
          <h2 className="mb-4 text-center text-md-start">{formatMessage({ id: 'blog_categories' })}</h2>
          <div className="d-flex flex-wrap justify-content-between mb-4">
            {availableCategories.map((category) => (
              <a
                key={`categoryFilter_${category}`}
                onClick={() => handleRoute({ category })}
                onKeyDown={() => handleRoute({ category })}
                tabIndex={0}
                role="link"
                className={`blogFacet me-1 ms-1 category ${category}${activeCategories.indexOf(category) > -1 ? ' active' : ''}`}
              >
                {formatMessage({ id: category.toLowerCase() })}
              </a>
            ))}
          </div>
          <h2 className="mb-4 text-center text-md-start">Tags</h2>
          <div className="d-flex flex-wrap justify-content-between mb-4">
            {availableTags.map((tag) => (
              <a
                key={tag}
                onClick={() => handleRoute({ tag })}
                onKeyDown={() => handleRoute({ tag })}
                role="link"
                tabIndex={0}
                className={`blogFacet me-1 ms-1 tag ${tag}${activeTags.indexOf(tag) > -1 ? ' active' : ''}`}
              >
                {formatMessage({ id: tag.toLowerCase() })}
              </a>
            ))}
          </div>
        </Col>
        <Col lg="9">
          {count === 0 && formatMessage({ id: 'blog-no-result' })}
          {blogposts &&
            blogposts.map((post) => <BlogpostTeaser dictionary={dictionary} post={post} key={post.id} wide path={path} />)}
          <Pager
            currentPage={pageInfo.currentPage}
            totalPages={pageInfo.totalPages}
            changePage={(page) => handleRoute({ page })}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Blog;
